import { ALLOW_LIST_VARIANT, CREDO_RAMPUP_FEATURE, RAMPED_UP_VARIANT, TYPE_CREDO_OPT_IN } from '../constants';
import queryCredoPreferences from '../data/queryCredoPreferences';
import queryCredoRampup from '../data/queryCredoRampup';
import { getCanCredoRedirect } from '../ducks';
import { getOrigin, getMappedAccountsWithMarkets } from '../selectors';
import { getMemberPreferenceByType, redirect } from '../utils';

// This redirector should be called in loadModuleData.
// It will block the server for less time, allowing for lower ttfb
export const credoRedirectInLoadModuleData = async (_ref, redirectToRoute, shouldRedirectFromPath) => {
  let {
    store,
    ownProps
  } = _ref;
  try {
    // Only redirect from the passed location and without product targeted
    const {
      location: {
        pathname,
        query: {
          account_key: accountKey,
          opaqueAccountId
        } = {}
      },
      credoXPFeature
    } = ownProps;
    if (pathname !== shouldRedirectFromPath || accountKey || opaqueAccountId) {
      return;
    }
    const origin = getOrigin(store.getState());
    let shouldRedirect = false;
    switch (credoXPFeature) {
      case CREDO_RAMPUP_FEATURE:
        {
          const {
            promise: rampupPromise
          } = queryCredoRampup({
            store
          });
          const {
            isEligible,
            variantType
          } = (await rampupPromise) || {};
          const {
            mappedAccounts
          } = getMappedAccountsWithMarkets(store.getState());
          shouldRedirect = isEligible && (variantType === RAMPED_UP_VARIANT || variantType === ALLOW_LIST_VARIANT) && mappedAccounts.length > 1;
          break;
        }
      default:
        {
          const {
            promise
          } = queryCredoPreferences({
            store,
            types: [TYPE_CREDO_OPT_IN],
            timeout: 1000
          });
          const credoPreferences = (await promise) || [];
          const isDefault = getMemberPreferenceByType(credoPreferences, TYPE_CREDO_OPT_IN);
          shouldRedirect = isDefault;
        }
    }
    if (shouldRedirect) {
      // eslint-disable-next-line no-throw-literal -- upstream library expects literal
      throw {
        abortComposeModules: true,
        redirect: {
          url: `${origin}${redirectToRoute}`
        }
      };
    }
  } catch (err) {
    // Re-throw the redirect error, ignore all others
    if (err.abortComposeModules) {
      throw err;
    }
  }
};

/** @deprecated Please use 'credoRedirectInLoadModuleData'. */
const credoRedirect = (store, redirectToRoute, pathToData) => (nextState, replace, callback) => {
  try {
    const {
      getState
    } = store;
    const state = getState();
    const canRedirect = getCanCredoRedirect(state, pathToData);
    const origin = getOrigin(state);
    let returnPromise = Promise.resolve([{
      type: TYPE_CREDO_OPT_IN,
      value: false
    }]);
    if (canRedirect) {
      const {
        promise
      } = queryCredoPreferences({
        store,
        types: [TYPE_CREDO_OPT_IN],
        timeout: 1000
      });
      returnPromise = promise;
    }
    return returnPromise.then(function () {
      let credoPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const isDefault = getMemberPreferenceByType(credoPreferences, TYPE_CREDO_OPT_IN);
      if (isDefault) {
        redirect(`${origin}${redirectToRoute}`, replace);
      }
      callback();
    }).catch(() => {
      callback();
    });
  } catch (err) {
    const returnPromise = Promise.resolve();
    return returnPromise.then(() => callback());
  }
};
export default credoRedirect;